module.exports = __webpack_public_path__ + "img/icon-change-cam.59c4add0.svg";